import { writable } from 'svelte/store';

export type ToastType = 'success' | 'info' | 'error';

type ToastParams = {
  type: ToastType;
  message: string;
};

type Toast = ToastParams & {
  id: number;
};

export const toasts = writable<Toast[]>([]);

let id = 0;
const getUniqueId = () => id++;

export const addToast = (toast: ToastParams) => {
  // Create a unique ID so we can easily find/remove it
  const id = getUniqueId();

  // Setup some sensible defaults for a toast.
  const defaults = {
    id,
    type: 'info'
  };

  // Push the toast to the top of the list of toasts
  toasts.update(all => [{ ...defaults, ...toast }, ...all]);

  setTimeout(() => dismissToast(id), 3000);
};

export const dismissToast = (id: number) => {
  toasts.update(all => all.filter(t => t.id !== id));
};
